import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UpdateBannerComponent } from './shared/components/update-banner/update-banner.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, UpdateBannerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'fe-tickets';
}
